import * as React from "react";
import { OTPInput, OTPInputContext } from "input-otp";
import { Dot } from "lucide-react";

import styles from "./inputOtp.module.scss";

const OtpInput = React.forwardRef<
  React.ElementRef<typeof OTPInput>,
  React.ComponentPropsWithoutRef<typeof OTPInput>
>(({ className, containerClassName, ...props }, ref) => (
  <OTPInput
    ref={ref}
    containerClassName={`${styles.container}${containerClassName ? ` ${containerClassName}` : ""}`}
    className={`${styles.input}${className ? ` ${className}` : ""}`}
    {...props}
  />
));

const OtpGroup = React.forwardRef<
  React.ElementRef<"div">,
  React.ComponentPropsWithoutRef<"div">
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={`${styles.group}${className ? ` ${className}` : ""}`}
    {...props}
  />
));

interface OtpSlotProps extends React.ComponentPropsWithoutRef<"div"> {
  index: number;
}

const OtpSlot = React.forwardRef<React.ElementRef<"div">, OtpSlotProps>(
  ({ index, className, ...props }, ref) => {
    const inputOTPContext = React.useContext(OTPInputContext);
    const { char, hasFakeCaret, isActive } = inputOTPContext.slots[index];

    return (
      <div
        ref={ref}
        className={`${styles.slot}${isActive ? ` ${styles.slotActive}` : ""}${className ? ` ${className}` : ""}`}
        {...props}
      >
        {char}
        {hasFakeCaret && (
          <div className={styles.caretContainer}>
            <div className={styles.caret} />
          </div>
        )}
      </div>
    );
  }
);

const OtpSeparator = React.forwardRef<
  React.ElementRef<"div">,
  React.ComponentPropsWithoutRef<"div">
>(({ ...props }, ref) => (
  <div ref={ref} {...props}>
    <Dot />
  </div>
));

export { OtpInput, OtpGroup, OtpSlot, OtpSeparator };
